import React, { useEffect } from 'react'
import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";
import he from "he";
import parse from "html-react-parser";
import api from '../../utils/api';
import { useNavigate, useParams } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";

const VerifyAnswer = () => {

    const { id } = useParams()
    const navigate = useNavigate()
    const [questions, setQuestions] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [confirmLoading, setConfirmLoading] = React.useState(false);


    async function fetchData() {
        try {
            setLoading(true);

            const fd = new FormData();
            fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
            fd.append("token", localStorage.getItem("authToken"));
            fd.append("programType", "printQuestions");
            fd.append("paperId", id);

            const response = await api.post("picQuestion/picQuestionCurl", fd);
            // console.log("Fetched questions:", response);

            if (response?.data && Array.isArray(response.data)) {
                setQuestions(response.data);
            } else {
                setQuestions([]);
            }
        } catch (error) {
            console.error("Error fetching questions:", error);
        } finally {
            setLoading(false);
        }
    }


    const renderLatexText = (text, layout = "single", fontSize = "16px") => {
        if (!text) return null;

        // Step 1: Decode HTML entities so <br/> becomes an actual tag
        let decodedText = he.decode(text);

        // Step 2: Replace <br> tags with newline characters
        decodedText = decodedText.replace(/<br\s*\/?>/gi, "\n");

        // Step 3: Regex for latex and images
        const latexAndImageRegex =
            /\\\((.*?)\\\)|\\\[(.*?)\\\]|<img[^>]*\bsrc=(["'])(.*?)\3[^>]*>|\\begin{align}([\s\S]*?)\\end{align}/g;

        const parts = [];
        let lastIndex = 0;
        let match;
        let key = 0;

        while ((match = latexAndImageRegex.exec(decodedText)) !== null) {
            const [fullMatch, inlineLatex, blockLatex, , imageSrc, alignContent] =
                match;
            const matchIndex = match.index;

            if (matchIndex > lastIndex) {
                const plainText = decodedText.slice(lastIndex, matchIndex);

                // Split plain text on \n and insert <br />
                plainText.split("\n").forEach((line, i, arr) => {
                    if (line) parts.push(<span className="3 normal-inline" key={`html-${key++}`}>{parse(line)}</span>);
                    if (i < arr.length - 1) parts.push(<br key={`br-${key++}`} />);
                });
            }

            if (imageSrc) {
                parts.push(
                    <img
                        key={`img-${key++}`}
                        src={imageSrc}
                        alt="Image"
                        style={{
                            maxWidth: `calc(${fontSize} * 18)`,
                            display: "inline",
                            verticalAlign: "middle",
                            marginLeft: "4px",
                            marginRight: "4px",
                        }}
                    />
                );
            } else if (alignContent) {
                parts.push(
                    <BlockMath key={`align-${key++}`}>
                        {`\\begin{align}${alignContent}\\end{align}`}
                    </BlockMath>
                );
            } else if (inlineLatex || blockLatex) {
                parts.push(
                    <InlineMath key={`inline-${key++}`}>
                        {inlineLatex || blockLatex}
                    </InlineMath>
                );
            }

            lastIndex = matchIndex + fullMatch.length;
        }

        if (lastIndex < decodedText.length) {
            const remaining = decodedText.slice(lastIndex);
            remaining.split("\n").forEach((line, i, arr) => {
                if (line) parts.push(<span className="2 normal-inline" key={`html-${key++}`}>{parse(line)}</span>);
                if (i < arr.length - 1) parts.push(<br key={`br-${key++}`} />);
            });
        }

        return <span className="1 " style={{ whiteSpace: "normal", display: "inline" }}>{parts}</span>;
    };

    const handleConfirmEvaluate = async () => {
        try {
            setConfirmLoading(true);

            const loggedInUser = localStorage.getItem("loggedInUser");
            const token = localStorage.getItem("authToken");

            const fd = new FormData();
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);
            fd.append("programType", "updateAnswerInPaper");
            fd.append("paperId", id);

            const response = await api.post("examPaper/exam", fd);

            // console.log("Evaluate Response:", response);
           

            toast.success(response.data.message); // optional success feedback
             navigate(-1); // go back to previous page
        } catch (error) {
            console.error(error);
            toast.error("Evaluation Failed ❌");
        } finally {
            setConfirmLoading(false);
        }
    };



    useEffect(() => {
        fetchData()
    }, []);

    return (
        <div style={{ padding: "16px", paddingBottom: "80px" }}>
            <h5 style={{ marginBottom: "12px" }}>Verify Answers</h5>

            {loading ? (

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", margin: "auto" }}>

                    <h3>Loading ...</h3>
                </div>

            ) : questions.length === 0 ? (
                <p>No questions found</p>
            ) : (
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "12px",
                    }}
                >
                    {questions.map((q, index) => (
                        <div
                            key={q.id}
                            style={{
                                border: "1px solid #e5e7eb",
                                borderRadius: "8px",
                                padding: "10px",
                                marginBottom: "10px",
                                background: "#fff",
                                fontSize: "14px",
                            }}
                        >
                            {/* ✅ QUESTION HEADER */}
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <b>Q{index + 1}.</b>

                                {/* ✅ EDIT BUTTON */}
                                <button
                                    onClick={() => navigate(`/add-question/${q.id}`)}
                                    style={{
                                        border: "none",
                                        background: "#eef2ff",
                                        color: "#3730a3",
                                        fontSize: "12px",
                                        padding: "4px 10px",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                    }}
                                >
                                    📝 Edit
                                </button>
                            </div>

                            {/* ✅ QUESTION TEXT */}
                            <div style={{ marginTop: "6px", marginBottom: "8px" }}>
                                {renderLatexText(q.question)}
                            </div>

                            {/* ✅ OPTIONS */}
                            {/* ✅ OPTIONS (2 COLUMN GRID) */}
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    gap: "8px",
                                }}
                            >
                                {q.options.map((opt, i) => {

                                    const isCorrect = opt === q.answer;

                                    return (
                                        <div
                                            key={i}
                                            style={{
                                                padding: "6px 10px",
                                                marginBottom: "5px",
                                                borderRadius: "6px",
                                                border: "1px solid #e5e7eb",
                                                background: isCorrect ? "#dcfce7" : "#f9fafb",
                                                color: isCorrect ? "#166534" : "#111827",
                                                fontWeight: isCorrect ? 600 : 400,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px",
                                            }}
                                        >
                                            <span>
                                                {String.fromCharCode(65 + i)}.
                                            </span>

                                            <span>{renderLatexText(opt)}</span>

                                            {isCorrect && (
                                                <span style={{ marginLeft: "auto", fontSize: "12px" }}>
                                                    ✅
                                                </span>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                  ))}
  </div>

                    
            )}

                    <ToastContainer />

                    {/* ✅ FIXED CONFIRM BUTTON AT BOTTOM */}
                    <div
                        style={{
                            position: "fixed",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            padding: "12px",
                            background: "#ffffff",
                            borderTop: "1px solid #e5e7eb",
                            display: "flex",
                            justifyContent: "center",
                            zIndex: 999,
                        }}
                    >
                        <button
                            onClick={handleConfirmEvaluate}
                            disabled={confirmLoading}
                            style={{
                                background: confirmLoading ? "#94a3b8" : "#3E80F9",
                                color: "#fff",
                                border: "none",
                                padding: "10px 24px",
                                borderRadius: "8px",
                                fontSize: "14px",
                                fontWeight: 600,
                                cursor: confirmLoading ? "not-allowed" : "pointer",
                                boxShadow: confirmLoading
                                    ? "none"
                                    : "0 4px 14px rgba(62,128,249,0.35)",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            {confirmLoading ? (
                                <>
                                    <span
                                        style={{
                                            width: "14px",
                                            height: "14px",
                                            border: "2px solid #fff",
                                            borderTop: "2px solid transparent",
                                            borderRadius: "50%",
                                            animation: "spin 1s linear infinite",
                                            display: "inline-block",
                                        }}
                                    />
                                    Evaluating...
                                </>
                            ) : (
                                "✅ Confirm Evaluate"
                            )}
                        </button>

                    </div>
                </div>
            );

}

            export default VerifyAnswer